export var STATUS_NONE = 'none';
export var STATUS_APPEAR = 'appear';
export var STATUS_ENTER = 'enter';
export var STATUS_LEAVE = 'leave';


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-motion/es/interface.js
// module id = 478
// module chunks = 0